// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__21shY","spin":"SectionTitle_spin__1CmRh","transition-opacity":"SectionTitle_transition-opacity__3zoYp"};